import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mr-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "6",
        sm: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            label: _ctx.$tt('collection-name-singular'),
            class: "required unique",
            "model-value": _ctx.value.name,
            "error-messages": _ctx.errorMessages.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => {_ctx.onInput('name', $event); _ctx.validateName($event)}),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateName()))
          }, null, 8, ["label", "model-value", "error-messages"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "6",
        sm: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_computed_input, {
            label: _ctx.$tt('collection-name-plural'),
            class: "required unique",
            value: _ctx.value.pluralName,
            "error-messages": _ctx.errorMessages.pluralName,
            onInput: _cache[2] || (_cache[2] = ($event: any) => {_ctx.onInput('pluralName', $event); _ctx.validatePluralName($event)}),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validatePluralName())),
            source: _ctx.value.name,
            manual: _ctx.manualPlural,
            "onInput:manual": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualPlural = $event)),
            compute: (text) => text? text + 's' : ''
          }, null, 8, ["label", "value", "error-messages", "source", "manual", "compute"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_computed_input, {
            label: _ctx.$tt('alias'),
            class: "required unique ontos-code",
            value: _ctx.value.alias,
            onInput: _cache[5] || (_cache[5] = ($event: any) => {_ctx.onInput('alias', $event); _ctx.validateAlias($event)}),
            onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateAlias())),
            "error-messages": _ctx.errorMessages.alias,
            source: _ctx.value.name,
            manual: _ctx.manualAlias,
            "onInput:manual": _cache[7] || (_cache[7] = ($event: any) => (_ctx.manualAlias = $event)),
            compute: _ctx.$utils.aliasSuggestion,
            computeOnInput: _ctx.$utils.incompleteAliasSuggestion,
            readonly: _ctx.fixedAlias
          }, null, 8, ["label", "value", "error-messages", "source", "manual", "compute", "computeOnInput", "readonly"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}